import axios from 'axios';
// eslint-disable-next-line import/prefer-default-export
export const attachAxiosInterceptor = (app) => {
    axios.interceptors.response.use((response) => response, (error) => {
        if (error.response.status === 500) {
            app.config.globalProperties.$toast.error('A critical error has occurred and the error has been reported. You may need to reload this page to continue.');
            error.handledGlobally = true;
        }
        return Promise.reject(error);
    });
};
